<template>
    <v-container>
        <v-row class="mt-3">
            <!-- LEFT SIDE -->
            <v-col cols="12" md="8">
                <v-row>
                    <v-col cols="12">
                        <pending-invitations/>
                    </v-col>

                    <!-- MY NAME -->
                    <v-col cols="12" class="hello-text text-capitalize">
                        {{ helloName }}
                    </v-col>

                    <!-- MY PANEL -->
                    <v-col cols="12">
                        <student-progress-table :student-id="studentId"/>
                    </v-col>

                    <!-- VIDEOS YOUTUBE -->
                    <v-col cols="12" v-show="showLinks">
                        <student-youtube-videos :coach-id="coachId" @show="showLinks = $event"/>
                    </v-col>

                    <!-- COMPETENCE -->
                    <v-col cols="12">
                        <student-competence :coach-id="coachId"/>
                    </v-col>
                </v-row>
            </v-col>

            <!-- RIGHT SIDE -->
            <v-col cols="12" md="4">
                <v-row>
                    <!-- CALENDAR -->
                    <v-col cols="12">
                        <calendar-student :student-id="studentId"/>
                    </v-col>
                    <!-- ACTUAL COACH -->
                    <v-col cols="12">
                        <current-coach/>
                    </v-col>
                    <!-- TRAINING TIME -->
                    <v-col cols="12">
                        <training-time-student :counter="studentCounter"/>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import PendingInvitations from "@/components/student/PendingInvitations";
import StudentProgressTable from "@/components/student/StudentProgressTable";
import CalendarStudent from "@/components/common/CalendarStudent";
import CurrentCoach from "@/components/student/CurrentCoach";
import StudentCompetence from "@/components/coach/StudentCompetence";
import TrainingTimeStudent from "@/components/student/TrainingTimeStudent";
import StudentYoutubeVideos from "@/components/student/StudentYoutubeVideos";

export default {
    components: {
        StudentYoutubeVideos,
        TrainingTimeStudent,
        StudentCompetence,
        PendingInvitations,
        StudentProgressTable,
        CalendarStudent,
        CurrentCoach,
    },
    data() {
        return {
            showLinks: false,
        }
    },
    computed: {
        helloName(vm = this) {
            return vm.$t('common.hello', {name: vm.account?.name || ''})
        },
        studentId(vm = this) {
            return vm.currentUser?.uid || null
        },
        coachId(vm = this) {
            return vm.account?.studentSubscription?.coachId || null
        },
        studentCounter(vm = this) {
            return vm.account?.counter || null
        }
    },
}
</script>

<style scoped>

.hello-text {
    font-size: 24px;
    line-height: 24px;
    font-weight: bold;
    color: #269999;
}

</style>
